<template>
  <div>
    <a-form :layout="formLayout">
      <a-form-item
        label="调整优先级"
        prop="level"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol">
        <a-popover placement="right" title="拖拽条件调整优先级顺序" width="250" trigger="click">
          <draggable slot="content" style="width: 100%; min-height:25px" :list="prioritySortList" group="from" :options="sortOption">
            <div
              :class="{'drag-no-choose': true, 'drag-hover': cd.id === selectedNode.id}"
              v-for="(cd, index) in prioritySortList"
              :key="index"
            >
              <e-ellipsis style="width: 160px;" hover-tip :content="cd.name"/>
              <div>优先级 {{ index + 1 }}</div>
            </div>
          </draggable>
          <a-button icon="swap" size="small">第{{ nowNodeLeave + 1 }}级</a-button>
        </a-popover>
      </a-form-item>
      <a-form-item
        label="条件组关系"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol">
        <a-switch
          v-model="configGroupsType"
          active-color="#409EFF"
          inactive-color="#c1c1c1"
          @change="configGroupsTypeChange"
          checked-children="且"
          un-checked-children="或">
        </a-switch>
      </a-form-item>
      <a-form-item
        label="条件组表达式"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol">
        <a-input v-model="config.expression" placeholder="输入条件组关系表达式  &为与，|为或"/>
        <span class="item-desc">使用表达式构建复杂逻辑，例如: (A & B) | C</span>
      </a-form-item>
    </a-form>
    <div>
      <a-button
        type="primary"
        icon="plus"
        style="margin: 0 15px 15px 0"
        shape="round"
        @click="addConditionGroup">
        添加条件组
      </a-button>
      <span class="item-desc">只有必填选项才能作为审批条件</span>
    </div>
    <group-item/>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import GroupItem from './ConditionGroupItemConfig.vue'
import { EEllipsis } from '@/components'

export default {
  name: 'ConditionNodeConfig',
  components: { draggable, GroupItem, EEllipsis },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    selectedNode () {
      return this.$store.state.oaApprove.selectedNode
    },
    select () {
      return this.config.assignedUser || []
    },
    nowNodeLeave () {
      return this.prioritySortList.indexOf(this.selectedNode)
    },
    // 条件节点
    prioritySortList () {
      const node = this.$store.state.oaApprove.nodeMap.get(this.selectedNode.parentId)
      console.log(this.selectedNode.id, node)
      if (node) {
        return node.branchs || []
      }
      return []
    },
    configGroupsType: {
      get () {
        return this.config.groupsType === 'AND'
      },
      set (value) {
        // newValue 是你赋的值（比如 true/false）
        this.config.groupsType = value ? 'AND' : 'OR'
      }
    },
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 }
        }
        : {}
    }
  },
  data () {
    return {
      formLayout: 'inline',
      sortOption: {
        animation: 300,
        chosenClass: 'choose',
        scroll: true,
        sort: true
      }
    }
  },
  methods: {
    addConditionGroup () {
      this.config.groups.push({
        cids: [],
        groupType: 'OR',
        conditions: []
      })
    },
    selectUser () {
      this.showOrgSelect = true
    },
    selected (select) {
      console.log(select)
      this.showOrgSelect = false
      select.forEach(val => this.select.push(val))
    },
    removeOrgItem (index) {
      this.select.splice(index, 1)
    },
    configGroupsTypeChange (value) {
      if (value) {
        this.config.groupsType = 'AND'
      } else {
        this.config.groupsType = 'OR'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.choose {
  border-radius: 5px;
  margin-top: 2px;
  background: #f4f4f4;
  border: 1px dashed #1890FF !important;
}

.drag-hover {
  color: #1890FF
}

.drag-no-choose {
  cursor: move;
  background: #f8f8f8;
  border-radius: 5px;
  margin: 2px 0;
  height: 35px;
  line-height: 35px;
  padding: 0px 10px;
  border: 1px solid #ffffff;
  div{
    display: inline-block;
    font-size: small !important;
  }

  div:nth-child(2) {
    float: right !important;
  }
}
</style>
